<div #autoInput class="outer-container">

    <mat-form-field class="container p-0 no-autocomplete-padding remove-mat-select-underline"
        [ngClass]="{ 'container-focused' : focused}" [style.width]="width">
        <mat-chip-list class="row" #chipList>
            <div>
                @for (item of selection; track item) {
                <mat-chip class="col-auto" [selectable]="false" [removable]="true" (removed)="toggleSelection(item)">
                    {{item.value}}
                    <mat-icon matChipRemove>cancel</mat-icon>
                </mat-chip>
                }

                <input #input class="py-2 autocomplete-input" type="text" [placeholder]="placeholder"
                    [matAutocomplete]="auto" [formControl]="userControl" (focus)="focused = true"
                    (focusout)="focused = false; " (click)="$event.stopPropagation()">
            </div>
            <mat-icon class="float-suffix" matSuffix>search</mat-icon>
        </mat-chip-list>
    </mat-form-field>
</div>

<mat-autocomplete #auto="matAutocomplete" appearance="outline" class="autocomplete no-autocomplete-padding"
    (opened)="opened()" [panelWidth]="width">
    @if (showSelectAll) {
    <mat-option [value]="selectAllValue.key">
        <div (click)="selectAllClick($event)">
            <mat-checkbox [checked]="selectAllSelected" (change)="selectAllClick($event)"
                (click)="$event.stopPropagation()">
                Select All
            </mat-checkbox>
        </div>
    </mat-option>
    <hr class="separator" />
    }


    @for (item of filteredItems | async; track item) {
    <mat-option [value]="item.key">
        <div (click)="optionClicked($event, item)">
            <mat-checkbox [checked]="isSelected(item)" (change)="toggleSelection(item, true)"
                (click)="$event.stopPropagation()">
                {{ item.value }}
            </mat-checkbox>
        </div>
    </mat-option>
    }
</mat-autocomplete>